import React from 'react';

function WelcomeFlagShip() {
  return (
    <div className="text-container flagship-copy-wrapper">
      <h1>AMSALE SoHo Flagship</h1>
      <p>
        Welcome to our NYC Flagship, located at 150 Wooster Street, SoHo.
        We’re excited to help curate a memorable wardrobe for you and your bridal party for your special day and all the celebrations leading up to it.
      </p>
      <br />
      <p>
        Please note that there is a $50 fee to reserve an appointment at the flagship.
        The appointment fee is a hold on your credit card that will be refunded after you attend your appointment.
        Should something come up, we kindly ask that you change or cancel with at least 24 hours' notice – changes or cancellations made within 24 hours will forfeit the deposit.
      </p>
      <br />
      <p>
        Available languages:
        <br />
        English, Spanish, Portuguese, Greek
      </p>
    </div>
  );
}

export default WelcomeFlagShip;
